import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Container, makeStyles, Typography } from '@material-ui/core'
import QrReader from 'react-qr-reader'

import { FONTS } from 'styles'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: '100vh',
    padding: theme.spacing(2),
  },
  scanner: {
    width: '100%',
    maxWidth: '400px',
    marginTop: theme.spacing(4),
  },
}))

export const QRScanner: React.FC = () => {
  const classes = useStyles()
  const history = useHistory()

  const handleScan = (data: string | null) => {
    if (data) {
      history.push(`/invoice/form/${data}`)
    }
  }

  const handleError = (err: Error) => {
    console.error(err)
  }

  return (
    <Container className={classes.container}>
      <Typography
        style={{
          fontFamily: FONTS.GOTHAM_LIGHT,
          fontSize: 30,
          fontWeight: 'bold',
        }}
      >
        Escanear factura
      </Typography>
      <QrReader
        delay={300}
        onError={handleError}
        onScan={handleScan}
        style={{ width: '100%' }}
        className={classes.scanner}
      />

      <Button
        variant="outlined"
        color="primary"
        style={{ marginTop: 40 }}
        onClick={() => history.push('/invoice/menu')}
      >
        Volver
      </Button>
    </Container>
  )
}
